/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestHasCommutedToday } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CommuteServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestHasCommutedToday 
     */
    commuteControllerHasUserCommutedToday0(apiRequestHasCommutedToday: ApiRequestHasCommutedToday, extraHttpRequestParams?: any): Observable<boolean>;

    /**
     * 
     * 
     * @param apiRequestHasCommutedToday 
     */
    commuteControllerHasUserCommutedToday1(apiRequestHasCommutedToday: ApiRequestHasCommutedToday, extraHttpRequestParams?: any): Observable<boolean>;

}
